import React, { useState, useEffect, memo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Header from "./Includes/Header";
import DashboardHeader from "./Includes/DashboardHeader";
import AdminHeader from "./Includes/AdminHeader";
import Footer from "./Includes/Footer";

const API = process.env.REACT_APP_API_URL || "";

const inputStyle = {
  width: "100%",
  padding: "12px 16px",
  border: "1.5px solid #e5e7eb",
  borderRadius: 10,
  fontSize: 14,
  color: "#111827",
  background: "#f9fafb",
  outline: "none",
  boxSizing: "border-box",
  fontFamily: "inherit",
};
const labelStyle = { fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 };
const errorStyle  = { fontSize: 12, color: "#ef4444", marginTop: 4, display: "block" };

const ContactUs = () => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === "ar";
  const { auth } = useSelector((state) => state);

  const [header, setHeader] = useState("guest");
  const [form, setForm]     = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle");
  const [serverMsg, setServerMsg] = useState("");

  useEffect(() => {
    if (auth.data) {
      const response = auth.data;
      if (response.status === 1) {
        setHeader(response.user?.role !== 1 ? "dashboard" : "admin");
        if (response.user) {
          setForm((f) => ({
            ...f,
            name:  f.name  || response.user.name  || "",
            email: f.email || response.user.email || "",
          }));
        }
      }
    }
  }, [auth]);

  const validate = () => {
    const errs = {};
    if (!form.name.trim())    errs.name    = isRtl ? "الاسم مطلوب" : "Name is required";
    if (!form.email.trim())   errs.email   = isRtl ? "البريد الإلكتروني مطلوب" : "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errs.email = isRtl ? "بريد إلكتروني غير صالح" : "Invalid email";
    if (!form.message.trim()) errs.message = isRtl ? "الرسالة مطلوبة" : "Message is required";
    return errs;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    if (errors[name]) setErrors((er) => { const n = { ...er }; delete n[name]; return n; });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setStatus("loading");
    try {
      const res = await axios.post(`${API}/api/contact`, form);
      if (res.data.status === 1) {
        setStatus("success");
        setServerMsg(res.data.message || (isRtl ? "تم إرسال رسالتك بنجاح!" : "Your message has been sent!"));
        setForm({ name: "", email: "", phone: "", subject: "", message: "" });
      } else {
        setStatus("error");
        setServerMsg(res.data.errors?.general || (isRtl ? "حدث خطأ. يرجى المحاولة مرة أخرى." : "An error occurred. Please try again."));
        if (res.data.errors) setErrors(res.data.errors);
      }
    } catch {
      setStatus("error");
      setServerMsg(isRtl ? "تعذر الاتصال بالخادم." : "Could not reach the server. Please try again.");
    }
  };

  return (
    <div dir={isRtl ? "rtl" : "ltr"}>
      {header === "guest" ? <Header /> : header === "dashboard" ? <DashboardHeader /> : <AdminHeader />}

      <div className="main_content">
        <div className="container_cust" style={{ maxWidth: 900, margin: "0 auto", padding: "40px 20px" }}>

          <div style={{ textAlign: "center", marginBottom: 40 }}>
            <h2 style={{ fontSize: 32, fontWeight: 800, color: "#0e3725", margin: "0 0 10px" }}>
              {isRtl ? "تواصل معنا" : "Contact Us"}
            </h2>
            <p style={{ fontSize: 15, color: "#6b7280", margin: 0 }}>
              {isRtl
                ? "يسعدنا سماع استفساراتكم وملاحظاتكم"
                : "We'd love to hear from you. Send us a message and we'll respond promptly."}
            </p>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1.6fr", gap: 40, alignItems: "start" }}>

            <div style={{ background: "linear-gradient(135deg,#0e3725,#1a5c3a)", borderRadius: 16, padding: "32px 28px", color: "#fff" }}>
              <h3 style={{ margin: "0 0 24px", fontSize: 18, fontWeight: 700, color: "#c9a84c" }}>
                {isRtl ? "معلومات التواصل" : "Contact Information"}
              </h3>
              {[
                { icon: "📍", label: isRtl ? "العنوان" : "Address", value: isRtl ? "٧٠٧٦ طريق الصحابة، إشبيلية ١٣٢٢٥، الرياض" : "7076 Al Sahaba Rd., Ishbiliyah 13225, Riyadh" },
                { icon: "✉️", label: isRtl ? "البريد الإلكتروني" : "Email", value: "partnerships@treasury.sa" },
              ].map((item) => (
                <div key={item.label} style={{ display: "flex", gap: 14, marginBottom: 20 }}>
                  <span style={{ fontSize: 20, flexShrink: 0, marginTop: 2 }}>{item.icon}</span>
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 600, color: "rgba(255,255,255,0.55)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 3 }}>{item.label}</div>
                    <div style={{ fontSize: 13.5, color: "#fff", lineHeight: 1.5 }}>{item.value}</div>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ background: "#fff", borderRadius: 16, padding: "32px 28px", boxShadow: "0 2px 16px rgba(0,0,0,0.07)" }}>
              {status === "success" ? (
                <div style={{ textAlign: "center", padding: "40px 20px" }}>
                  <div style={{ width: 64, height: 64, borderRadius: "50%", background: "#d1fae5", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                    <svg width="28" height="28" fill="none" stroke="#16a34a" strokeWidth="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                  </div>
                  <h3 style={{ fontSize: 18, fontWeight: 700, color: "#0e3725", margin: "0 0 8px" }}>
                    {isRtl ? "تم الإرسال!" : "Message Sent!"}
                  </h3>
                  <p style={{ fontSize: 14, color: "#6b7280", margin: "0 0 20px" }}>{serverMsg}</p>
                  <button onClick={() => setStatus("idle")} style={{ background: "#0e3725", color: "#fff", border: "none", borderRadius: 8, padding: "10px 24px", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
                    {isRtl ? "إرسال رسالة أخرى" : "Send Another Message"}
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} noValidate>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
                    <div>
                      <label style={labelStyle}>{isRtl ? "الاسم *" : "Full Name *"}</label>
                      <input name="name" value={form.name} onChange={handleChange} placeholder={isRtl ? "الاسم الكامل" : "Your full name"} style={{ ...inputStyle, borderColor: errors.name ? "#ef4444" : "#e5e7eb" }} />
                      {errors.name && <span style={errorStyle}>{errors.name}</span>}
                    </div>
                    <div>
                      <label style={labelStyle}>{isRtl ? "البريد الإلكتروني *" : "Email Address *"}</label>
                      <input name="email" type="email" value={form.email} onChange={handleChange} placeholder={isRtl ? "بريدك الإلكتروني" : "your@email.com"} style={{ ...inputStyle, borderColor: errors.email ? "#ef4444" : "#e5e7eb", direction: "ltr" }} />
                      {errors.email && <span style={errorStyle}>{errors.email}</span>}
                    </div>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
                    <div>
                      <label style={labelStyle}>{isRtl ? "رقم الجوال" : "Phone Number"}</label>
                      <input name="phone" value={form.phone} onChange={handleChange} placeholder={isRtl ? "اختياري" : "Optional"} style={{ ...inputStyle, direction: "ltr" }} />
                    </div>
                    <div>
                      <label style={labelStyle}>{isRtl ? "الموضوع" : "Subject"}</label>
                      <input name="subject" value={form.subject} onChange={handleChange} placeholder={isRtl ? "موضوع رسالتك" : "What is this about?"} style={inputStyle} />
                    </div>
                  </div>
                  <div style={{ marginBottom: 20 }}>
                    <label style={labelStyle}>{isRtl ? "الرسالة *" : "Message *"}</label>
                    <textarea name="message" value={form.message} onChange={handleChange} rows={5} placeholder={isRtl ? "اكتب رسالتك هنا..." : "Write your message here..."} style={{ ...inputStyle, resize: "vertical", borderColor: errors.message ? "#ef4444" : "#e5e7eb" }} />
                    {errors.message && <span style={errorStyle}>{errors.message}</span>}
                  </div>
                  {status === "error" && (
                    <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#dc2626" }}>
                      {serverMsg}
                    </div>
                  )}
                  <button type="submit" disabled={status === "loading"} style={{ width: "100%", padding: "13px 20px", background: status === "loading" ? "#6b7280" : "linear-gradient(135deg,#0e3725,#1a5c3a)", color: "#fff", border: "none", borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: status === "loading" ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                    {status === "loading" ? (
                      <>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ animation: "spin 1s linear infinite" }}><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>
                        {isRtl ? "جارٍ الإرسال..." : "Sending..."}
                      </>
                    ) : (isRtl ? "إرسال الرسالة" : "Send Message")}
                  </button>
                  <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default memo(ContactUs);
